import {
  Activity, Flower2, Dumbbell, Flame, Swords, Sparkles, Hand, ThermometerSun,
} from "lucide-react";

export const CATEGORY_ICONS = {
  pilates: Activity,
  yoga: Flower2,
  fitness: Dumbbell,
  crossfit: Flame,
  boxing: Swords,
  spa: Sparkles,
  masaj: Hand,
  sauna: ThermometerSun,
};

export const CATEGORY_LABELS = {
  pilates: "Pilates",
  yoga: "Yoga",
  fitness: "Fitness",
  crossfit: "CrossFit",
  boxing: "Boxing",
  spa: "Spa",
  masaj: "Masaj",
  sauna: "Sauna",
};

export const DAYS_TR = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];
export const MONTHS_TR = [
  "Oca", "Şub", "Mar", "Nis", "May", "Haz",
  "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara",
];

export function formatDate(iso) {
  const d = new Date(iso + (iso.length === 10 ? "T00:00:00" : ""));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const dd = new Date(d);
  dd.setHours(0, 0, 0, 0);
  if (dd.getTime() === today.getTime()) return "Bugün";
  if (dd.getTime() === tomorrow.getTime()) return "Yarın";
  const dayIdx = (d.getDay() + 6) % 7;
  return `${DAYS_TR[dayIdx]}, ${d.getDate()} ${MONTHS_TR[d.getMonth()]}`;
}

export function shortDate(iso) {
  const d = new Date(iso + "T00:00:00");
  return `${d.getDate()} ${MONTHS_TR[d.getMonth()]}`;
}

export const BOOKING_STATUS = {
  confirmed: { label: "Onaylandı", color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  attended: { label: "Katıldı", color: "bg-blue-100 text-blue-700 border-blue-200" },
  no_show: { label: "Gelmedi", color: "bg-amber-100 text-amber-700 border-amber-200" },
  cancelled: { label: "İptal Edildi", color: "bg-rose-100 text-rose-700 border-rose-200" },
};
